module.exports = __webpack_public_path__ + "img/homepage-interest-grey.1e509ca4.svg";